import { Dispatch, SetStateAction, useState } from 'react';
import { useDebounce } from 'use-debounce';

export function useDebouncedState<T>(
  initialValue: T,
  delay: number,
): [T, Dispatch<SetStateAction<T>>, T] {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue] = useDebounce(value, delay);
  return [debouncedValue, setValue, value]; // include non-debounced value as third member
}
